import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { GlobalWorkerOptions } from 'pdfjs-dist';
GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@3.2.146/build/pdf.worker.min.js';

const PdfViewer = (props: any) => {
  return (
    <div style={{ height: '750px' }}>
      <Worker workerUrl={GlobalWorkerOptions.workerSrc}>
        <Viewer fileUrl={props.pdfUrl} />
      </Worker>
    </div>
  );
};

export default PdfViewer;
